<template lang="pug">
.text-sm
  div {{ $t('you_can_insert_field_into') }}
  v-textarea.mt-4.round-xl(ref="textarea" v-model="finalMessage" @input="updateCursor" @change="updateCursor" @focus="updateCursor" placeholder="Eg: Hi, thank you for..." hide-details outlined auto-grow)
  .mt-4.mb-2 {{ $t('insert_field') }}
  v-chip.mb-2.mr-1.text-xs(outlined v-for="field in templateField" :key="field.id" @click="insertValue(field.id)") {{ field.label }}
  .my-4(v-if="finalMessage")
    .text-md.font-semibold.mb-4 {{ $t('message_preview') }}
    v-card.pa-4(outlined)
      div(v-html="formatInput(formattedMessage)")
</template>

<script>
export default {
  props: ['message'],
  data: () => ({
    textArea: null,
    templateField: [
      { id: 'name', label: 'Name' },
      { id: 'phone', label: 'Phone'},
      { id: 'email', label: 'Email'},
      { id: 'nickname', label: 'Nickname'},
      { id: 'age', label: 'Age'},
      { id: 'occupation', label: 'Occupation'},
      { id: 'gender', label: 'Gender'},
      { id: 'marital_status', label: 'Marital Status'},
      { id: 'facebook', label: 'Facebook'},
      { id: 'twitter', label: 'Twitter'},
      { id: 'instagram', label: 'Instagram'},
      { id: 'tiktok', label: 'TikTok'},
    ],
  }),
  computed: {
    finalMessage: {
      get() {
        return this.message
      },
      set(newValue) {
        this.$emit('update:message', newValue)
      }
    },
    formattedMessage () {
      if (this.finalMessage) {
        let message = this.finalMessage
        message = message.split('{{name}}').join('Customer Name')
        message = message.split('{{phone}}').join('60111111111')
        message = message.split('{{email}}').join('example@gmail.com')
        message = message.split('{{products_description}}').join('1. Burger (x1)<br> - cheese (x1)')
        message = message.split('{{store_link}}').join('https://yezza.store/example')
        message = message.split('{{nickname}}').join('customer nickname')
        message = message.split('{{age}}').join('25')
        message = message.split('{{occupation}}').join('student')
        message = message.split('{{gender}}').join('male')
        message = message.split('{{marital_status}}').join('single')
        message = message.split('{{facebook}}').join('facebook.com/user')
        message = message.split('{{twitter}}').join('twitter.com/user')
        message = message.split('{{instagram}}').join('instagram.com/user')
        message = message.split('{{tiktok}}').join('tiktok.com/user')
        let largestIndex = 0
        message.split('{{').forEach(word => { 
          word.split('}}').forEach(w => {
            if (w.includes('extra_')) {
              const index = parseInt(w.split('_')[1])
              if (largestIndex < index) {
                largestIndex = index
              }
            }
          })
        })
        for (var i = 0; i < largestIndex + 1; i++) {
          if (this.fields && this.fields.length > i) {
            let field = this.fields[i]
            message = message.split(`{{extra_${i}}}`).join(field.name)
          } else {
            message = message.split(`{{extra_${i}}}`).join('')
          }
        }        
        return message
      }
      return this.finalMessage
    }
  },
  mounted() {
    this.textarea = this.$refs.textarea.$el.querySelector('textarea')
  },
  methods: {
    updateCursor () {
      const position = this.textarea.selectionStart
      if (!position) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue(value) {
      this.finalMessage = `${this.finalMessage.substring(0, this.cursorPosition)}{{${value}}}${this.finalMessage.substring(this.cursorPosition, this.finalMessage.length)}`
    },
    formatInput(string) {
      string = String(string);
      
      let bold = string.split(" ").map((word) => {
        if (/\*/.test(word) && !/^\**$/.test(word))
          if (/(^(~\*)|^(_\*)|^\*)(.*)(\*$|(\*_)$|(\*\W)$)/.test(word))
            return word.replace(/\*([^\r\n]+)\*/g, "<b>$1</b>")
          else if (/[_*~]\*(.*)\*[~*_]/.test(word))
            return word.replace(/\*([^*][^\r\n]+[^*])\*/g, "<b>$1</b>");
        return word
      }).join(" ")

      let italic = bold.split(" ").map((word) => {
        if (/_/.test(word) && !/^_+$/.test(word))
        if (/(^~_|^_<.*>|^_\*|^_)(.*)(_$|(_<.*>)$|(_\*)$|(_\W)$)/.test(word))
          return word.replace(/_([^\r\n]+)_/g, "<i>$1</i>");
        else if (/(~|_|\*|<.*>)_(.*)_(<.*>|\*|~|_)/.test(word))
          return word.replace(/_([^_][^\r\n]+[^_])_/g, "<i>$1</i>");
        return word
      }).join(" ")
      
      let strikethrough = italic.split(" ").map((word) => {
        if (/~/.test(word) && !/^~+$/.test(word))
          if (/(^_~|^~<.*>|^\*~|^~)(.*)(~$|(~_)$|(~<.*>)$|(~\*)$|(~\W)$)/.test(word))
            return word.replace(/~([^\r\n]+)~/g, "<del>$1</del>")
          else if (/(~|_|\*|<.*>)~(.*)~(<.*>|\*|~|_)/.test(word))
            return word.replace(/~([^~][^\r\n]+[^~])~/g, "<del>$1</del>")
        return word
      }).join(" ")
      
      let underline = strikethrough.split(" ").map(function(word) {
        if (/%/.test(word) && !/^%+$/.test(word))
          if (/(^_%|^~%|^%<.*>|^\*%|^%)(.*)(%$|(%~)$|(%_)$|(%<.*>)$|(%\*)$|%\W+$)/.test(word))
            return word.replace(/%([^\r\n]+)%/g, "<u>$1</u>")
          else if (/(%|~|_|\*|<.*>)%(.*)%(<.*>|\*|~|%|_)/.test(word))
            return word.replace(/%([^%][^\r\n]+[^%])%/g, "<u>$1</u>")
        return word
      }).join(" ")

      let monospace = underline.split(" ").map(function(word) {
        if (/```/.test(word))
          if (/```(.|\n|\r)*(.+)(.|\n|\r])*```/.test(word)) 
            return word.replace(/```((.|\n|\r)*(.*)(\r|\n|.)*)```/g, `<span style="font-family: 'Courier New', Courier, monospace">$1</span>`);
        return word;
      }).join(" ");
        
      let formatted = monospace
      
      if (/\*(.*)\*/.test(formatted))
        formatted = formatted.replace(/(^|[\s_>~%`])\*([^\s\r\n]+[^*\n\r]+[^\s\r\n]+)\*([\W_\r\n\s]|$)/g, "$1<b>$2</b>$3");

      if (/_(.*)_/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~%`*])_([^\s\r\n]+[^_\n\r]+[^\s\n\r]+)_([\W_\s\r\n]|$)/g, "$1<i>$2</i>$3");
      
      if (/~(.*)~/.test(formatted))
        formatted = formatted.replace(/(^|[\s>%`*_])~([^\s\r\n]+[^~\r\n]+[^\r\n\s]+)~([\W_\s\r\n]|$)/g, "$1<del>$2</del>$3");
      
      if (/%(.*)%/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~`*_])%([^\s\r\n]+[^%\r\n]+[^\r\n\s]+)%([\W_\s\r\n]|$)/g, "$1<u>$2</u>$3");

      var counter = 0
      if (/```/.test(formatted)) {
        var i = 0;
        formatted = formatted.split(" ")
        formatted = formatted.map(function(word) {
          if (!/<code>/.test(word))
            if (/```/.test(word) && formatted[i+1] != "```")
            {
              i++; counter++
              if (counter % 2 != 0) 
                return word.replace("```", "<code>")
              else
                return word.replace("```", "</code>")
            } i++;
          return word
        }).join(" ")

        if (counter % 2 == 1) {
          formatted = formatted.split(" ");
          for (i = formatted.length-1; i >= 0; i--)
            if (/<code>/.test(formatted[i]))
            {
              formatted[i] = formatted[i].replace(/<code>/, "```")
              break;
            }
          formatted = formatted.join(" ")
        }
      }
      return formatted
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #c1c1c1;
}
</style>